export default "__VITE_ASSET__Cijm$3YP__"